import { render, staticRenderFns } from "./courseOnDemandSlider.vue?vue&type=template&id=6677d6a2&"
import script from "./courseOnDemandSlider.vue?vue&type=script&lang=js&"
export * from "./courseOnDemandSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6677d6a2')) {
      api.createRecord('6677d6a2', component.options)
    } else {
      api.reload('6677d6a2', component.options)
    }
    module.hot.accept("./courseOnDemandSlider.vue?vue&type=template&id=6677d6a2&", function () {
      api.rerender('6677d6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/Components/Organisms/slider/courseOnDemandSlider.vue"
export default component.exports